// Preview only; the server assigns the final code inside the write transaction.
export const getNextItemCode = (items = [], parent = null, officialItems = []) => {
  const parentCode = String(parent?.itemCode ?? parent?.ItemCode ?? "");
  const prefix = parentCode ? `${parentCode}.` : "";
  // Imported items marked Delete remain official until approval synchronization.
  // Their codes are still counted by the server even though the draft list hides them.
  const next = [...items, ...officialItems].reduce((max, item) => {
    const code = String(item.itemCode ?? item.ItemCode ?? "");
    if (!code.startsWith(prefix)) return max;
    const suffix = code.slice(prefix.length);
    return /^\d+$/.test(suffix) ? Math.max(max, Number(suffix)) : max;
  }, 0) + 1;
  return `${prefix}${next}`;
};
